import { CSSProperties } from 'react';

import { CustomerHouseMap } from '~src/components/GoogleMap/CustomerHouseMap';
import { Heading } from '~src/components/Typography';
import { Address, AddressWithGeolocation } from '~src/model';

type AddressWithMapProps = {
  address?: Address | AddressWithGeolocation;
  style?: CSSProperties;
};

export const AddressWithMap = ({ address, style }: AddressWithMapProps) => {
  if (!address) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexFlow: 'row wrap', alignItems: 'center', ...style }}>
      <CustomerHouseMap address={address} />

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Heading level={3} color='light'>
          Adresse
        </Heading>

        <FormattedAddress address={address} />
      </div>
    </div>
  );
};

const FormattedAddress = ({ address }: Required<Pick<AddressWithMapProps, 'address'>>) => {
  const { street, city, postalCode, houseNumber, floor, door } = address;

  return (
    <>
      <Heading level={2} style={{ fontWeight: 400 }} color='light'>
        {street} {houseNumber} {floor}
        {door}
      </Heading>

      <Heading level={2} style={{ fontWeight: 400 }} color='light'>
        {postalCode} {city}
      </Heading>
    </>
  );
};
